import { Box, Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useState } from 'react';

export const FileInput = ({label, onChange, accept, error, required = true}) => {
    const [inputValue, setInputValue] = useState('');

    const onChangeFile = (event) => {
        const {target: {value, files}} = event;
        const fileName = value.replace(/^.*[\\\/]/, '')
        setInputValue(fileName);
        onChange(files[0])
    }

    return (
        <Box sx={{display: 'flex', gap: '1rem'}} required>
            <TextField
                margin="normal"
                readOnly
                fullWidth
                value={inputValue}
                error={error}
                label={label}
                size="small"
                required={required}
                sx={{mb: 1, mt: 1}}
            />
            <Button variant="contained" component="label" sx={{mt: 1, mb: 1, pt: 0, pb: 0}}>
                Upload
                <input
                    hidden
                    accept={accept}
                    type="file"
                    onChange={onChangeFile}
                />
            </Button>
        </Box>
    );
}
